import React from 'react';
import { Box, Typography } from '@mui/material';

const NearbyAttractionsTab = ({ secondaryTextSx }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
    <Typography variant="h6" sx={{ color: '#ffffff' }}>Atracciones Cercanas</Typography>
    <Typography variant="body2" sx={secondaryTextSx}>
      No hay información de atracciones cercanas disponible.
    </Typography>
  </Box>
);

export default NearbyAttractionsTab;
